export default "__VITE_ASSET__DbyKpONG__"